import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgEvervizAdweek = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 646 45"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <style>{".cls-1{fill:#757575}"}</style>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="MC_Logo_" data-name="MC Logo">
        <path
          d="m142.1 21.52-9.6-13.1h-4.6v20.8h4.4v-13.5l9.9 13.5h4.3V8.42h-4.4Zm-21.1-6.4c0-3.9-2.6-6.7-7-6.7h-9.7v20.8h4.4v-7.4h3.2l4.1 7.4h5.1l-4.6-7.9a5.9 5.9 0 0 0 4.5-6.2M113.4 18h-4.6v-5.7h4.9a2.8 2.8 0 0 1 2.8 2.8v.3a3 3 0 0 1-3.1 2.6m40.8 11.2h4.4V8.42h-4.4ZM0 3.32V15l15.5 15.5L31 15V3.32l-15.5 15.5Zm31.1 31.1v-11.7l-11.7 11.7ZM57.9 21 52.8 8.42h-6.2v20.8H51v-14.5l5.9 14.5h1.9l5.9-14.5v14.5h4.4V8.42h-6.2ZM86.8 8a10.9 10.9 0 1 0 10.9 10.9A10.9 10.9 0 0 0 86.8 8M93 18.82c0 3.9-2.5 6.8-6.3 6.8s-6.3-2.9-6.3-6.8S82.9 12 86.7 12s6.3 2.9 6.3 6.8ZM0 34.42h11.7L0 22.72Zm309.6-20.3c0-1.3 1.1-2.1 3-2.1a9 9 0 0 1 6 2.3l2.5-3.2a11.8 11.8 0 0 0-8-2.9c-4.9 0-7.9 2.9-7.9 6.3 0 7.8 12 5.3 12 9 0 1.2-1.2 2.3-3.6 2.3A9.06 9.06 0 0 1 307 23l-2.4 3.3a12 12 0 0 0 8.8 3.3c5.6 0 8.3-2.9 8.3-6.7-.2-7.78-12.1-5.48-12.1-8.78Zm32.8 6.7a4.52 4.52 0 0 1-4.1 4.9 5.34 5.34 0 0 1-.8 0h-.8a4.49 4.49 0 0 1-4.1-4.86V8.42h-4.5v12.5c0 5.1 3 8.6 9.4 8.6s9.4-3.5 9.4-8.7V8.42h-4.5ZM359 8.42h-4.4v20.8h13.2v-3.9H359Zm-178.5 13.1-9.6-13.1h-4.5v20.8h4.4v-13.5l9.9 13.5h4.2V8.42h-4.4v13.1Zm189.6-9.2h6.1v16.9h4.4v-16.9h6v-3.9H370v3.9Zm-168.5 9.3h5.5v2.5a7 7 0 0 1-4.4 1.6h-.4a6.41 6.41 0 0 1-6.11-6.7.34.34 0 0 0 0-.1v-.4a6.4 6.4 0 0 1 6.4-6.4h.1a5.79 5.79 0 0 1 4.9 2.7l3.7-2a9.44 9.44 0 0 0-8.6-4.6c-6.1 0-11.1 4.2-11.1 10.8s5 10.8 11.1 10.8a11.35 11.35 0 0 0 8.8-3.9v-8h-9.9Zm92.1-.1-9.6-13.1h-4.5v20.8h4.4v-13.5l9.9 13.5h4.3V8.42h-4.4Zm-63-3.1a6.47 6.47 0 0 1 6.5-6.4 5.61 5.61 0 0 1 4.9 3l3.8-1.9A9.64 9.64 0 0 0 237.2 8c-6.2 0-11.1 4.4-11.1 10.8s4.9 10.8 11.1 10.8a9.61 9.61 0 0 0 8.7-5.1l-3.8-1.8a5.5 5.5 0 0 1-4.9 3h-.4a6.41 6.41 0 0 1-6.11-6.7.34.34 0 0 0 0-.1ZM262 8a10.9 10.9 0 1 0 10.9 10.9A10.86 10.86 0 0 0 262.08 8Zm0 17.7c-3.8 0-6.3-2.9-6.3-6.8s2.5-6.8 6.3-6.8 6.3 2.9 6.3 6.8-2.5 6.82-6.3 6.82ZM393.6 3.32a2.66 2.66 0 0 0-2.6 2.6 2.6 2.6 0 1 0 5.2 0 2.52 2.52 0 0 0-2.44-2.6Zm1.3 4.1-.8-1.2a1 1 0 0 0 .7-.9 1 1 0 0 0-1-1h-1.3v3h.6v-1h.4l.7 1.1za2.06 2.06 0 0 1-1.3.5 2 2 0 1 1 2-2 1.83 1.83 0 0 1-.7 1.5Zm-1.1-1.7h-.7v-.8h.7a.43.43 0 0 1 .4.4.43.43 0 0 1-.4.4"
          className="cls-1"
        />
        <path
          d="M427.3 3.36v31.1"
          style={{
            fill: "none",
            stroke: "#757575",
            strokeMiterlimit: 10,
            strokeWidth: ".5px",
          }}
        />
      </g>
      <g id="AdWeek_logo" data-name="AdWeek logo">
        <path
          d="M562.11 35.82h.43c.19 0 .4.07.4.31s-.26.3-.5.3h-.33v.12h.41l.47.72h.15l-.47-.72a.42.42 0 0 0 .4-.41c0-.29-.15-.44-.51-.44H562v1.57h.14v-1.45Z"
          className="cls-1"
        />
        <path
          d="M562.46 35.16a1.33 1.33 0 1 1-1.33 1.33 1.32 1.32 0 0 1 1.31-1.33v.12a1.17 1.17 0 0 0-1.19 1.15v.06a1.19 1.19 0 1 0 1.19-1.21ZM549.27 36.52h-6.24V0h6.24v14.31L552.48 0h6.68l-4.21 14.65 4.44 21.87h-6.5l-2.27-15.82-1.35 2.76zM530 30.38h-6.06v-9.61h4.78v-6.13h-4.78V5.7H530V0h-12.66v36.52H530zM542.48 30.38h-5.8v-9.61h4.58v-6.13h-4.58V5.7h5.8V0h-12.1v36.52h12.1zM491.83 0l4.47 36.52h6.77l1.7-23.48 2.22 23.48h5.82L516.93 0h-5.16l-1.27 20.52L508.33 0h-6.68l-1.75 20.2L497.77 0zM487 0h-10.32v36.52H487c2.65 0 4.8-3.1 4.8-6.92V6.93C491.83 3.1 489.68 0 487 0m-1.39 28.72c0 1.39-.63 2.52-1.4 2.52h-1.09V5.7h1.09c.77 0 1.4 1.13 1.4 2.52ZM472.24 0h-9.45l-4.38 36.55h5.65l.66-8.17h3.94l.66 8.17h7Zm-6.7 23.32 1.58-15.6 1.59 15.6Z"
          className="cls-1"
        />
      </g>
    </g>
  </svg>
);
export default SvgEvervizAdweek;
